<template>
  <div class="flex items-center gap-2">
    <div class="">
      <h5 v-if="title" class="font-semibold">{{ title }}</h5>
      <div v-html="text"></div>
    </div>
    <!-- <button @click="$emit('close-toast')" class="text-sm">
      <BaseIcon name="close" />
    </button> -->
  </div>
</template>

<script setup>
import BaseIcon from "@/components/base/BaseIcon.vue";
defineEmits(["close-toast"]);
defineProps({ text: { type: String }, title: { type: String, default: null } });
</script>
